common.View.create('website::admin.settings.Advanced', {

    onDOMLoad() {
        this.initCodeEditor();
    },

    initCodeEditor() {
        // Define editors
        const editors = {
            'jsEditorAlfa': 'javascript',
            'jsEditorBravo': 'javascript',
            'cssEditorAlfa': 'css',
        }

        // Create editors
        $.each(editors, (index, value) => {
            // Find textarea dom
            let textareaDom = this.element.find('.' + index + ' textarea')[0];

            // Create CodeMirror from textarea
            CodeMirror.fromTextArea(textareaDom, {
                mode: value,
                theme: 'ttcn',
                lineNumbers: true,
                gutter: true,
                lineWrapping: true,
                matchBrackets: true,
                tabMode: "indent",
            }).setSize(null, 500);
        });
    }
});
